import React from 'react';
import DatePicker from 'react-datepicker';
import { TimeInputLayoutProps } from 'ui-builder';
import { Clock } from 'lucide-react';
import { Input } from 'shadcn-ui';
import ShadcnBaseInputLayout from '../../../form/layout/ShadcnBaseInputLayout';

import 'react-datepicker/dist/react-datepicker.css';
import styles from './ShadcnDatePicker.module.scss';

const ShadcnTimeTrigger = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'>
>(({ value, onClick, placeholder, disabled }, ref) => (
  <div className="relative">
    <Clock className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-gray-400 pointer-events-none" />
    <Input
      ref={ref}
      value={(value as string) || ''}
      onClick={onClick}
      placeholder={placeholder}
      disabled={disabled}
      readOnly
      className="!pl-9 cursor-pointer"
    />
  </div>
));
ShadcnTimeTrigger.displayName = 'ShadcnTimeTrigger';

function ShadcnTimeInputLayout(props: TimeInputLayoutProps) {
  const value = props.value || null;

  return (
    <ShadcnBaseInputLayout
      label={props.label}
      afterLabelElement={props.afterLabelElement}
      name={props.name}
      errors={props.errors}
      hideLabel={props.hideLabel}
      showRequiredIcon={props.showRequiredIcon}
      hideValidationErrors={props.hideValidationErrors}
      hint={props.hint}
      className={props.className}
    >
      <div className={styles.shadcnTimePicker}>
        <DatePicker
          selected={value}
          placeholderText={props.placeholder}
          disabled={props.isDisabled}
          onChange={(date: Date) => {
            props.onChangeCallback({
              target: {
                value: date,
              },
            });
          }}
          showTimeSelect
          showTimeSelectOnly
          dateFormat="hh:mm aa"
          customInput={<ShadcnTimeTrigger />}
        />
      </div>
    </ShadcnBaseInputLayout>
  );
}

export default ShadcnTimeInputLayout;
